import '@splidejs/splide/dist/css/splide.min.css';

import Splide from '@splidejs/splide';

const isOverflown = (element, length) => {
  if (!element) return;

  const width = element.getBoundingClientRect().width * length;
  return width > window.innerWidth;
};

const FullCycleOfPlant = () => {
  const splideFullCycleOfPlant = '.js-fullCycleOfPlant';
  const splideFullCycleOfPlantElement = document.querySelector(
    splideFullCycleOfPlant
  );

  if (splideFullCycleOfPlantElement) {
    if (splideFullCycleOfPlantElement.classList.contains('no-js')) {
      splideFullCycleOfPlantElement.classList.remove('no-js');
    }

    const { lastElementChild } = splideFullCycleOfPlantElement;

    const length = splideFullCycleOfPlantElement?.children?.length;

    const CONFIG_SPLIDE = {
      arrows: false,
      pagination: isOverflown(lastElementChild, length),
      drag: isOverflown(lastElementChild, length),
      perPage: 4,
      autoWidth: true,
      autoHeight: true,
      gap: '32px',
      breakpoints: {
        1280: {},
        1024: {
          perPage: 3,
          pagination: true,
          drag: true,
          padding: {
            left: '3rem',
            right: '3rem'
          },
          gap: '1rem'
        },
        768: {
          perPage: 1,
          pagination: true,
          drag: true,
          gap: '1rem',
          padding: {
            left: '1rem',
            right: '1rem'
          }
        }
      }
    };

    new Splide(splideFullCycleOfPlant, CONFIG_SPLIDE).mount();
  }
};

export default FullCycleOfPlant;
